import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { TAG_ARCHIVED_PLACES } from 'services/TagsConstants';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.mutation<void, string>({
    query: (id) => ({
      url: `/place/${id}/unarchive`,
      method: 'POST',
    }),
    invalidatesTags: [TAG_ARCHIVED_PLACES],
  });
